import { css } from '@emotion/react'
import clsx from 'clsx'
import { LinkList } from 'nsw-ds-react'
import { LinkListProps } from 'nsw-ds-react/dist/component/link-list/linkList'

// NSW section variants where text is light (--nsw-text-light).
// Inside these, link-list links must use light color, otherwise the NSW DS
// default `var(--nsw-brand-dark)` is invisible on dark backgrounds.
const darkSectionParentSelector = [
	'.nsw-section--brand-dark &',
	'.nsw-section--brand-supplementary &',
	'.nsw-section--black &',
	'.nsw-section--grey-01 &',
	'.nsw-section--grey-02 &',
	'.nsw-section--invert &',
].join(', ')

// Border color overrides — match the NSW design system theme reference.
// https://designsystem.nsw.gov.au/components/link-list/theme.html
const themeAwareCss = css`
	/* Default border color (white / off-white / grey-03 sections) */
	& .nsw-link-list__item {
		border-color: var(--nsw-grey-04);
	}

	/* Brand-light (light blue) — borders use NSW navy for clear contrast */
	.nsw-section--brand-light & .nsw-link-list__item {
		border-color: var(--nsw-brand-dark);
	}

	/* Grey-04 background — borders use slightly darker grey */
	.nsw-section--grey-04 & .nsw-link-list__item {
		border-color: var(--nsw-grey-03);
	}

	/* Dark sections — semi-transparent white borders for subtle contrast */
	.nsw-section--brand-dark & .nsw-link-list__item,
	.nsw-section--brand-supplementary & .nsw-link-list__item,
	.nsw-section--black & .nsw-link-list__item,
	.nsw-section--grey-01 & .nsw-link-list__item,
	.nsw-section--grey-02 & .nsw-link-list__item,
	.nsw-section--invert & .nsw-link-list__item {
		border-color: rgba(255, 255, 255, 0.3);
	}

	/* Link color override for dark theme sections */
	${darkSectionParentSelector} {
		& a,
		& a:visited,
		& a:hover,
		& a:focus {
			color: var(--nsw-text-light);
		}
	}

	&& a[target='_blank']:after {
		content: none;
	}
`

export const NswLinkList = (props: LinkListProps) => {
	return (
		<LinkList
			{...props}
			css={themeAwareCss}
			className={clsx(
				String.raw`[&_.nsw-link-list\_\_icon]:shrink-0`,
				props.className,
			)}
		/>
	)
}
